(function () {
  'use strict';

  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var bar = document.getElementById('marbenio-sticky-atc');
  if (!bar) return;

  var submitId = bar.getAttribute('data-submit-id');
  var mainBtn = submitId ? document.getElementById(submitId) : null;
  if (!mainBtn) return;

  var stickyBtn = bar.querySelector('.marbenio-sticky-atc__btn');
  if (!stickyBtn) return;

  var shown = false;
  var showTimer = null;
  var hideTimer = null;

  function setVisible(next) {
    if (shown === next) return;
    shown = next;
    bar.classList.toggle('is-visible', next);
    bar.setAttribute('aria-hidden', next ? 'false' : 'true');
  }

  function syncStickyButton() {
    stickyBtn.disabled = mainBtn.disabled;
    var mainLabel = mainBtn.querySelector('span');
    var stickyLabel = stickyBtn.querySelector('span');
    if (mainLabel && stickyLabel) {
      stickyLabel.textContent = mainLabel.textContent;
    }
  }

  syncStickyButton();

  if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, syncStickyButton);
  }

  var btnObserver = new MutationObserver(syncStickyButton);
  btnObserver.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], subtree: true, childList: true });

  var visibilityObserver = new IntersectionObserver(
    function (entries) {
      var inView = entries[0].isIntersecting;
      clearTimeout(showTimer);
      clearTimeout(hideTimer);

      if (inView) {
        hideTimer = setTimeout(function () {
          setVisible(false);
        }, 100);
      } else {
        showTimer = setTimeout(function () {
          setVisible(true);
        }, 250);
      }
    },
    { threshold: 0, rootMargin: '0px 0px 8px 0px' }
  );

  visibilityObserver.observe(mainBtn);
})();
